import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppRoutingModule } from './app.routing';
import { AppComponent } from './app.component';
import { HomeComponent } from './components/home/home.component';
import { ModuleComponent } from './components/module/module.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FlexLayoutModule } from '@angular/flex-layout'
import { LayoutModule } from '@angular/cdk/layout';
import { MaterialModule } from './app.material-module';
import { ModuleResponsesComponent } from './components/module-responses/module-responses.component';
import { UserComponent } from './components/user/user.component';
import { NodeFormComponent } from './components/node-form/node-form.component';
import { ModuleFormComponent } from './components/module-form/module-form.component';
import { SortablejsModule } from 'ngx-sortablejs';
import { SettingsComponent } from './components/settings/settings.component';
import { ModuleFormQuestionComponent } from './components/module-form/module-form-question/module-form-question.component';
import { ModuleFormSlideComponent } from './components/module-form/module-form-slide/module-form-slide.component';
import { LibraryComponent } from './components/library/library.component';
import { ContentSelectDialogComponent } from './components/content-select-dialog/content-select-dialog.component';
import { ContentGridComponent } from './components/content-grid/content-grid.component';
import { ContentGridElementDisplayComponent } from './components/content-grid-element-display/content-grid-element-display.component';
import { AmplifyAuthenticatorModule } from '@aws-amplify/ui-angular'
import { AdminComponent } from './components/admin/admin.component';
import { EditUserDialogComponent } from './components/edit-user-dialog/edit-user-dialog.component';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    ModuleComponent,
    ModuleResponsesComponent,
    UserComponent,
    NodeFormComponent,
    ModuleFormComponent,
    SettingsComponent,
    ModuleFormQuestionComponent,
    ModuleFormSlideComponent,
    LibraryComponent,
    ContentSelectDialogComponent,
    ContentGridComponent,
    ContentGridElementDisplayComponent,
    AdminComponent,
    EditUserDialogComponent
],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    FlexLayoutModule,
    LayoutModule,
    MaterialModule,
    SortablejsModule.forRoot({ animation: 150 }),
    AmplifyAuthenticatorModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
